<template>
  <!-- 车辆类型 -->
  <div class="vehicletype">

    <el-form class="bginput" label-width="8rem">

      <el-form-item label="新能源车数量">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="formData.newEnergyCar" placeholder="请录入"><template slot="suffix">台</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="新能源车本月里程">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)" v-model="formData.mileage" placeholder="请录入"><template slot="suffix">公里</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="减少二氧化碳排放">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 10) value=value.slice(0, 10)" v-model="formData.carbon" placeholder="请录入"><template slot="suffix">公斤</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <br>
      <el-form-item label="自有车辆">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="formData.ownCar" placeholder="请录入"><template slot="suffix">台</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="租赁车辆">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="formData.leaseCar" placeholder="请录入"><template slot="suffix">台</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="外包货运">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="formData.epibolyCar" placeholder="请录入"><template slot="suffix">台</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="客户自运">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-input type="number" oninput="if(value.length > 4) value=value.slice(0, 4)" v-model="formData.customSelfCar" placeholder="请录入"><template slot="suffix">台</template></el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <div style="margin-top: 2rem;">
            <el-button @click="save" size="small" type="primary">保存设置</el-button>
          </div>
    </el-form>

  </div>
</template>

<script>
import api from '@/apis/transportation/vehicletype'
export default {
  data() {
    return {
      value1: '',
      formData: {
        carbon: '', //减少二氧化碳排放
        customSelfCar: '', //客户自运
        epibolyCar: '', //外包货运
        leaseCar: '', //租赁车辆
        mileage: '', //新能源车本月里程
        newEnergyCar: '', //新能源车数量
        ownCar: '', //自有车辆
      },
    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  methods: {
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.vehicletype { padding-top:10px;
  .el-form-item {
    margin: bottom 15px;;
  }
}
</style>